// DataSource لمزودي الخدمة
// يمكنك تعديل المسار أو طريقة الجلب حسب البنية الفعلية لمشروعك
import {Http} from '../../../Data/config/Http';
import {ServiceProviderDTO, ServiceProviderWithBrandsDTO, AssignBrandDTO, UnassignBrandDTO, UnassignBrandResponseDTO, CreateProviderRequestDTO, UpdateProviderRequestDTO} from '../models/serviceProvider.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';
import type {MyBrands, ProviderBrand} from '../../../types/ServiceProviderTypes';

export const ServiceProviderAPIDataSource = {
  // جلب جميع مزودي الخدمة
  getAll: async (page = 1, limit: number = PAGINATION_CONFIG.DEFAULT_PAGE_SIZE): Promise<{ items: ServiceProviderDTO[]; pagination?: any }> => {
    try {
      const response = await Http.get<BaseResponse<ServiceProviderDTO[]>>(API_ROUTES.SERVICE_PROVIDERS.BASE, {params: {page, limit}});
      const raw = response.data;
      const items = unwrapResponse(raw, 'حدث خطأ في جلب مزودي الخدمة');
      return {
        items,
        pagination: raw.pagination
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // جلب مزود خدمة محدد مع برانداته
  getById: async (id: string): Promise<ServiceProviderWithBrandsDTO> => {
    try {
      const response = await Http.get<BaseResponse<ServiceProviderWithBrandsDTO>>(API_ROUTES.SERVICE_PROVIDERS.BY_ID(id));
      return unwrapResponse(response.data, 'حدث خطأ في جلب مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // جلب إحصائيات مزود الخدمة
  getStats: async (id: string): Promise<any> => {
    try {
      const response = await Http.get<BaseResponse<any>>(API_ROUTES.SERVICE_PROVIDERS.STATS(id));
      return unwrapResponse(response.data, 'حدث خطأ في جلب إحصائيات مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // إنشاء مزود خدمة جديد
  create: async (providerData: CreateProviderRequestDTO): Promise<ServiceProviderDTO> => {
    try {
      // providerData already in snake_case from Repository layer
      const response = await Http.post<BaseResponse<ServiceProviderDTO>>(API_ROUTES.SERVICE_PROVIDERS.BASE, providerData);
      return unwrapResponse(response.data, 'حدث خطأ في إنشاء مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // تحديث مزود خدمة
  update: async (id: string, providerData: UpdateProviderRequestDTO): Promise<ServiceProviderDTO> => {
    try {
      // providerData already in snake_case from Repository layer
      const response = await Http.put<BaseResponse<ServiceProviderDTO>>(API_ROUTES.SERVICE_PROVIDERS.BY_ID(id), providerData);
      return unwrapResponse(response.data, 'حدث خطأ في تحديث مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // حذف مزود خدمة
  delete: async (id: string): Promise<void> => {
    try {
      const response = await Http.delete<BaseResponse<void>>(API_ROUTES.SERVICE_PROVIDERS.BY_ID(id));
      unwrapResponse(response.data, 'حدث خطأ في حذف مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // ربط براند بمزود الخدمة
  assignBrand: async (assignData: AssignBrandDTO): Promise<void> => {
    try {
      const response = await Http.post<BaseResponse<void>>(API_ROUTES.SERVICE_PROVIDERS.ASSIGN_BRAND, assignData);
      unwrapResponse(response.data, 'حدث خطأ في ربط البراند');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // إلغاء ربط براند من مزود الخدمة
  unassignBrand: async (unassignData: UnassignBrandDTO): Promise<UnassignBrandResponseDTO> => {
    try {
      const response = await Http.delete<BaseResponse<UnassignBrandResponseDTO>>(API_ROUTES.SERVICE_PROVIDERS.UNASSIGN_BRAND, {data: unassignData});
      return unwrapResponse(response.data, 'حدث خطأ في إلغاء ربط البراند');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // جلب براندات مزود الخدمة
  getProviderBrands: async (): Promise<any[]> => {
    try {
      const response = await Http.get<BaseResponse<any[]>>(API_ROUTES.SERVICE_PROVIDERS.GET_PROVIDER_BRANDS);
      return unwrapResponse(response.data, 'حدث خطأ في جلب براندات مزود الخدمة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // جلب برانداتي (للحالي مزود الخدمة)
  getMyBrands: async (): Promise<MyBrands | ProviderBrand[] | undefined> => {
    try {
      const response = await Http.get<BaseResponse<MyBrands | ProviderBrand[] | null>>(API_ROUTES.SERVICE_PROVIDERS.GET_MY_BRANDS);
      const data = unwrapResponse(response.data, 'حدث خطأ في جلب برانداتي');
      return data ?? undefined;
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // جلب متاجر البراند
  getBrandStores: async (brandId: string): Promise<any[]> => {
    try {
      const response = await Http.get<BaseResponse<any[]>>(API_ROUTES.SERVICE_PROVIDERS.GET_BRAND_STORES(brandId));
      return unwrapResponse(response.data, 'حدث خطأ في جلب متاجر البراند');
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};
